// extracted by mini-css-extract-plugin
export var galleryItemContainer = "AutomaticRowsGallery-module--galleryItemContainer--2b205";